import RegisterContainer from './register.container';
import { RegistrationSuccess } from './children';
export default RegisterContainer;
export { RegistrationSuccess };
